import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button, message } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { saveBankDetailsAdress, uploadBankDetailsAdress, approveRejectBankDetail, approveRejectUserDocument } from '../action/user.actions'
import { fromValidate } from '../../../helpers';
import _ from 'lodash';
import { imageEndpoint } from '../../../services/endpoint';

class BankDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bank_detail: {},
      document: {},
      user_bank_detail: {}
    }
  }

  componentDidMount() {
    const { user } = this.props;
    this.setState({ bank_detail: user.bank_detail });

  }
  componentWillReceiveProps( props){
    const { user, userDetails } = props;
    const user_bank_detail = user.role.name == 'Admin' ? (userDetails.bank_detail ) || [] : (user.bank_detail ) || [];
    const document = user.role.name == 'Admin' ? (userDetails.bank_detail && userDetails.bank_detail.documents) || [] : (user.bank_detail && user.bank_detail.documents) || [];
    const doc = _.first(document);
    this.setState({doc:doc, user_bank_detail:user_bank_detail});
  }

  handleChange = (e) => {
    const bank_detail = Object.assign({}, this.state.bank_detail)
    const name = e.target.name;
    const value = e.target.value;
    bank_detail[name] = value;
    this.setState({ bank_detail });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  onSelectFile = (e) => {
    const { user } = this.props;
    const document = Object.assign({}, this.state.document)
    let file = e.target.files[0];
    if (file) {
      document.photo = file;
      document.user_id = user.id;
      document.document_type = file.type;
      document.document_name = document.document_name || 'Passbook / Check';
      this.setState({ document: document })
    }
    // dispatch(uploadIdentityverification(user.id, formData))
  }

  onSelectDocumentName = (e) => {
    const document = Object.assign({}, this.state.document);
    document.document_name = e.target.value;
    this.setState({ document: document })
  }



  saveFirmAddress = (e) => {
    const { user, dispatch } = this.props;
    let { bank_detail, document } = this.state;
    e.preventDefault();
    this.setState({ formError: {}, formSubmit: true })
    const formValidation = fromValidate(e.target);
    if (!formValidation.valid) {
      this.setState({ formError: formValidation.invalidationEle })
    }
    else {

      let req = {
        "user_id": user.id,
        "account_no": bank_detail.account_no,
        "account_holder_name": bank_detail.account_holder_name,
        "account_type": bank_detail.account_type,
        "bank_ifsc": bank_detail.bank_ifsc
      }

      dispatch(saveBankDetailsAdress(user.id, req))
        .then((res) => {
          if (document) {
            let fromData = this.createFormData(document)
            dispatch(uploadBankDetailsAdress(user.id, fromData));
            this.setState({ document: {} })
          }
        });
    }
  }
  approveRejectUserDocument = (id, status) => {
    const {dispatch, user} = this.props;
    const data = {
      document_id: id,
      status: status
    }
    dispatch(approveRejectUserDocument(data, user.id)).then((res) => {
      let doc = [...this.state.doc];
      let currentDoc = doc.find(e => e.id == id);
      currentDoc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({document: doc})
    })
    .catch((err) => {
      console.log(err);
    });;
  }
  approveRejectBankDetail= (id, status) =>{
    const {dispatch, user} = this.props;
    const data = {
      user_id: id,
      status: status
    }
    dispatch(approveRejectBankDetail(data)).then((res)=>{
      let doc = this.state.user_bank_detail;
      doc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({user_bank_detail: doc})
    })
    .catch((err) => {
      console.log(err);
    });
  }

  render() {
    const { user, userDetails } = this.props;
    const role = user.role.name
    const { bank_detail } = this.state;
    const document = role == 'Admin'? (userDetails.bank_detail && userDetails.bank_detail.documents) || []: (userDetails.bank_detail && userDetails.bank_detail.documents) || [];
    const {doc, user_bank_detail} = this.state;

    return (
      <div className="form-main-cont-box">
        <div className="upprof-heading-txt">Bank Detail
          {
            role == "Admin" && 
            <span className='verification-button-container'>
              <Button type="button" disabled={user_bank_detail.status === "Verified"} className="ant-btn btn-login" onClick={() => { this.approveRejectBankDetail(userDetails.id, 'V')}} ><span>{user_bank_detail.status == "V"? "Approved" : "Approve Bank Detail"}</span></Button>
              <Button type="button" disabled={user_bank_detail.status === "Rejected"} className="ant-btn btn-reject" onClick={() => { this.approveRejectBankDetail(userDetails.id, 'R')}}><span>{user_bank_detail.status == "R"? "Rejected" : "Reject Bank Detail"}</span></Button>
            </span>
          }
        </div>
        <form ref={node => this.fromNode = node} noValidate autoComplete="off" onSubmit={(e) => { this.saveFirmAddress(e) }}>
          <div className="row row-padding">
            <div className="col-sm-12 col-md-8 col-xs-12">
              {
                role != "Admin" && 
                <div>
                  <input
                    type="text"
                    className='prof-textfield-containt'
                    placeholder="Account Number"
                    name="account_no"
                    value={bank_detail.account_no}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                  <input
                    type="text"
                    className='prof-textfield-containt'
                    placeholder="Account Holder Name"
                    name="account_holder_name"
                    value={bank_detail.account_holder_name}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                  <select defaultValue='Select Bank'
                    name="account_type"
                    value={bank_detail.account_type}
                    onChange={(e) => { this.handleChange(e) }}
                    className="prof-textfield-containt">
                    <option value={0}>Select Account Type</option>
                    <option value="C">Current</option>
                    <option value="S">Saving</option>
                  </select>

                  <input
                    type="text"
                    className='prof-textfield-containt'
                    placeholder="IFSC"
                    name="bank_ifsc"
                    value={bank_detail.bank_ifsc}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                </div>
              }{
                role == "Admin" && 
                <div>
                  <div>
                    <label>{bank_detail.account_no}</label>
                  </div>
                  <div>
                    <label>{bank_detail.account_holder_name}</label>
                  </div>
                  <div>
                    <label>{bank_detail.account_type}</label>
                  </div>
                  <div>
                    <label>{bank_detail.bank_ifsc}</label>
                  </div>
                </div>
              }
             
            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e) }} />
                  </div>
                  <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Upload Passbook/Check</label>
                {
                  role == "Admin" &&  
                  <div>
                    <Button type="submit" disabled={ doc && doc.status === "Verified"} className="ant-btn btn-login" onClick={() => {this.approveRejectUserDocument(doc && doc.id, 'V')}}><span>{ doc && doc.status == "Verified" ? 'Approved' : "Approve"}</span></Button>
                    <Button type="button" disabled={ doc && doc.status === "Rejected"} className="ant-btn btn-reject" onClick={() => {this.approveRejectUserDocument(doc && doc.id, 'R')}}><span>{ doc && doc.status == "Rejected" ? 'Rejected' : "Reject"}</span></Button>
                  </div>
                }
              </div>
            </div>
          </div>
          {
            role != "Admin" &&  
            <div>
              <Button htmlType="submit" className='btn-login'>SAVE</Button>
            </div>
          }
         
        </form>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(BankDetail);